<template>
  <v-card>
    <v-form @submit.prevent="submitEditProject()" ref="editProjectForm">
      <v-container grid-list-lg>
        <v-layout wrap>
          <v-flex xs12 class="flex-container-space-between">
            <span class="headline">
              Edit
              <span class="grey--text subheading">- {{project.name}}</span>
            </span>
            <div>
              <v-switch
                color="indigo"
                class="mt-0"
                label="Active project"
                v-model="editedProject.active"
              ></v-switch>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="editedProject.name"
              label="* Name"
              autofocus
              :loading="loading"
              :rules="nameRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
              label="Allocation matching"
              :items="['SITE', 'PROJECT']"
              v-model="editedProject.allocationMatchType"
              item-text="name"
              :rules="allocationMatchRules"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="different">
          <v-btn :color="primaryGrey" flat @click="discard()">Discard?</v-btn>
          <v-btn :color="primaryGreen" flat type="submit" :loading="loading">Save</v-btn>
        </div>
        <div v-else>
          <v-btn :color="primaryGrey" flat @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-form>
    <v-container>
      <v-layout>
        <v-flex>
          <v-expansion-panel expand class="grey lighten-3">
            <v-expansion-panel-content v-model="tipPanel" class="grey lighten-4">
              <div
                slot="header"
                class="font-weight-medium grey--text text--darken-2 vertical-center-container"
              >
                <v-icon :color="tipColor" class="mr-2">{{this.$store.state.global.pages.tip.icon}}</v-icon>Allowed Tips
              </div>

              <v-list subheader>
                <v-list-tile v-for="tip in tips" :key="tip.id" fluid>
                  <v-checkbox
                    v-model="selectedTips"
                    :label="tip.name"
                    :value="tip.id"
                    :color="tipColor"
                  ></v-checkbox>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-checkbox v-model="selectAllTips" :color="tipColor">
                    <div slot="label" class="font-weight-bold">Select All</div>
                  </v-checkbox>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import ProjectService from "@/services/requests/projectService";
import ProjectTipService from "@/services/requests/projectTipService";
import ProjectValidation from "@/services/validation/projectValidation";
export default {
  mixins: [ProjectValidation],
  data() {
    return {
      editedProject: Object.assign({}, this.project),
      loading: false,
      selectedTips: [],
      currentTips: [],
      allTips: [],
      tipPanel: false,
      tipColor: this.$store.state.global.pages.tip.color,
      selectAllTips: false
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    discard() {
      this.editedProject = Object.assign({}, this.project);
      this.selectedTips = this.currentTips;
      this.close();
    },
    submitEditProject() {
      if (!this.$refs.editProjectForm.validate()) {
        this.snack({ text: "Please correct form errors", color: "red" });
        return;
      }
      this.save();
    },
    getProjectTipsByProject() {
      ProjectTipService.getProjectTipsByProject(this.project.id)
        .then(result => {
          this.setCurrentTips(result.data.result);
        })
        .catch(err => {
          this.snackError();
          console.log(err);
        });
    },
    setCurrentTips(data) {
      this.selectedTips = [];
      this.currentTips = [];
      for (var record of data) {
        this.selectedTips.push(record.tipId);
        this.currentTips.push(record.tipId);
      }
    },
    save() {
      var postedProject = this.editedProject;
      postedProject.selectedTips = this.selectedTips;
      this.loading = true;
      console.log(this.editedProject);
      ProjectService.updateProject(this.editedProject)
        .then(result => {
          this.loading = false;
          this.$store.commit("projects/updateArrayStateByValue", {
            prop: "projects",
            value: this.project,
            editedValue: result.data.result.project
          });
          this.editedProject = Object.assign({}, result.data.result.project);
          this.setCurrentTips(result.data.result.projectTips);
          this.snack({ text: "Project was edited!", color: "green" });
          this.close();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.snackError();
        });
    }
  },
  props: {
    project: Object
  },
  computed: {
    tips: Store.getSet({ store: "tips", prop: "tips" }),
    different() {
      if (
        !this._.isEqual(this.project, this.editedProject) ||
        !this._.isEqual(
          this.selectedTips.sort().join(","),
          this.currentTips.sort().join(",")
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  async mounted() {
    await this.getProjectTipsByProject();
    for (var tip of this.tips) {
      this.allTips.push(tip.id);
    }
  },
  watch: {
    selectAllTips(val) {
      val ? (this.selectedTips = this.allTips) : (this.selectedTips = []);
    }
  }
};
</script>

<style>
</style>